// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RestaurantsRouteImport } from './routes/restaurants'
import { Route as IndexRouteImport } from './routes/index'
import { Route as EventsEventNameRouteImport } from './routes/events/$eventName'

const RestaurantsRoute = RestaurantsRouteImport.update({
            id: '/restaurants',path: '/restaurants',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const EventsEventNameRoute = EventsEventNameRouteImport.update({
            id: '/events/$eventName',path: '/events/$eventName',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,RestaurantsRoute: RestaurantsRoute,EventsEventNameRoute: EventsEventNameRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)